import { motion } from "framer-motion";
import { SectionHead, Reveal, EASE } from "./Reveal";
import { PROCESS, PROCESS_VALUES } from "../content";

export const Process = () => (
  <section id="process" className="relative overflow-hidden py-28 md:py-36 bg-[#0d1013] border-y border-white/10" data-testid="process-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <SectionHead
        index="06"
        label="Our search process"
        title={<>Disciplined. Transparent. <em className="text-emerald-400">Client-centric.</em></>}
      />
      <div className="relative mt-20">
        <motion.div
          className="absolute left-0 right-0 top-[27px] hidden h-px origin-left bg-gradient-to-r from-emerald-400 via-emerald-400/60 to-white/10 lg:block"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 1.8, ease: EASE }}
        />
        <div className="absolute bottom-0 left-[27px] top-0 w-px bg-white/10 lg:hidden" />
        <ol className="grid grid-cols-1 gap-12 lg:grid-cols-5 lg:gap-8">
          {PROCESS.map((s, i) => (
            <Reveal key={s.t} delay={0.15 + i * 0.12}>
              <li className="group relative flex gap-6 lg:block" data-testid={`process-step-${i}`}>
                <span className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-full border border-emerald-400/50 bg-[#0d1013] font-mono text-sm text-emerald-300 transition-colors duration-500 group-hover:bg-emerald-500 group-hover:text-[#0a0c0e]">
                  0{i + 1}
                </span>
                <div className="lg:mt-8">
                  <p className="font-display text-3xl text-zinc-100">{s.t}</p>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed lg:pr-4">{s.d}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
      <Reveal className="mt-20 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-white/10 pt-8">
        {PROCESS_VALUES.map((v, i) => (
          <span key={v} className="flex items-center gap-8 font-mono text-xs uppercase tracking-[0.2em] text-zinc-300">
            {v}
            {i < PROCESS_VALUES.length - 1 && <span className="h-1 w-1 rounded-full bg-emerald-400" />}
          </span>
        ))}
      </Reveal>
    </div>
  </section>
);
